import { Loader } from '@googlemaps/js-api-loader';

export default defineNuxtPlugin((nuxtApp) => {
  const googleMapsApiKey = useRuntimeConfig().public.googleMapsKey;

  const loader = new Loader({
    apiKey: googleMapsApiKey,
    libraries: ['places', 'marker']
  });

  nuxtApp.provide('googleMapsLoader', loader);

  const googleMapsService = {
    createIconElement(icon) {
      const content = document.createElement("img");
      content.src = icon.url;
      content.setAttribute("class", "w-9 h-9 rounded-full shadow object-cover");
      content.style.width = '36px';
      content.style.height = '36px';
      return content;
    }
  };

  nuxtApp.provide('googleMapsService', googleMapsService);

});
